export const IMAGE_WIDTHS = [320, 480, 768, 960, 1280, 1600, 1920] as const;
export const CARD_IMAGE_SIZES = '(max-width: 640px) 100vw, (max-width: 1000px) 50vw, 320px';
export const ATLAS_CARD_SIZES = '(max-width: 760px) 50vw, (max-width: 1000px) 33vw, 240px';
export const ATLAS_FEATURED_SIZES = '(max-width: 760px) 100vw, (max-width: 1000px) 66vw, 480px';
export const DETAIL_IMAGE_SIZES =
  '(max-width: 800px) calc(100vw - 32px), (max-width: 1280px) 65vw, 880px';
// The mobile map is a pannable 680px canvas, not a viewport-width thumbnail.
export const MAP_IMAGE_SIZES =
  '(max-width: 760px) 680px, (max-width: 1000px) 840px, min(calc(100vw - 160px), clamp(1000px, calc((100svh - 300px) * 2), 1480px))';

/** Public raster files only: never turn this into a remote URL proxy. */
export function isResizableImage(src: string): boolean {
  return /^\/(?:art|media\/uploads)\/(?:[a-zA-Z0-9_-]+\/)*[a-zA-Z0-9_-]+\.(?:webp|png|jpe?g|avif)$/.test(
    src,
  );
}
export function imageUrl(src: string, width: number): string {
  return `/images/resize?src=${encodeURIComponent(src)}&w=${width}`;
}
export function responsiveImage(src: string | undefined, sizes = CARD_IMAGE_SIZES) {
  if (!src || !isResizableImage(src)) return { src, sizes: undefined, srcSet: undefined };
  return {
    src: imageUrl(src, 960),
    srcSet: IMAGE_WIDTHS.map((width) => `${imageUrl(src, width)} ${width}w`).join(', '),
    sizes,
  };
}
